import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { NAV, PRODUCTS, CONTACT } from "@/lib/data";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative z-10 bg-forest text-paper">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h3 className="font-serif text-4xl leading-none">Mysore Paper</h3>
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-paper/60 mt-2">
              Suppliers Corporation · Est. 1970
            </p>
            <p className="mt-6 max-w-sm text-paper/70 leading-relaxed">
              A three-generation paper trading house supplying dependable paper and board to
              printers, publishers, packaging companies and trade buyers across India.
            </p>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-cta"
              className="group mt-8 inline-flex items-center gap-2 rounded-full border border-paper/30 px-6 py-3 text-sm font-semibold transition-colors duration-300 hover:bg-paper hover:text-forest"
            >
              Talk to us on WhatsApp
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-paper/50 mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-paper/75 hover:text-paper transition-colors duration-300">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-paper/50 mb-5">Products</p>
            <ul className="space-y-3">
              {PRODUCTS.map((p) => (
                <li key={p.slug}>
                  <Link to="/products" className="text-paper/75 hover:text-paper transition-colors duration-300">
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-paper/50 mb-5">Get in touch</p>
            <ul className="space-y-4 text-paper/75">
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-1 shrink-0 text-paper/50" />
                <span>{CONTACT.address.join(" ")}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-paper/50" />
                <a href={`tel:${CONTACT.phoneMobileRaw}`} className="hover:text-paper transition-colors">{CONTACT.phoneMobile}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-paper/50" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-paper transition-colors break-all">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-paper/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-paper/50">
          <p>© {new Date().getFullYear()} Mysore Paper Suppliers Corporation. All rights reserved.</p>
          <p className="font-mono text-[11px] tracking-wide">Three generations of paper trade · Since 1970</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
